export const GET_QUARATINE_REPORT_REQUEST = "GET_QUARATINE_REPORT_REQUEST";
export const GET_QUARATINE_REPORT_SUCCESS = "GET_QUARATINE_REPORT_SUCCESS";
export const GET_QUARATINE_REPORT_FAILURE = "GET_QUARATINE_REPORT_FAILURE";

export const GET_QUARANTINE_DOWNLOAD_REQUEST = "GET_QUARANTINE_DOWNLOAD_REQUEST";
export const GET_QUARANTINE_DOWNLOAD_SUCCESS = "GET_QUARANTINE_DOWNLOAD_SUCCESS";
export const GET_QUARANTINE_DOWNLOAD_FAILURE = "GET_QUARANTINE_DOWNLOAD_FAILURE";
 